import { t } from 'i18next';
import { ApiError } from './ApiError';
import { ErrorResponse } from '@/errorHandling';

export function isSyntacticError(error: Error): error is SyntacticError {
  return error.constructor === SyntacticError;
}

export class SyntacticError extends ApiError {
  constructor(response: Response, errorResponse?: ErrorResponse) {
    super(response, errorResponse);
  }

  static async create(response: Response) {
    const errorResponse = await super.extractError(response);

    const newError = new SyntacticError(response, errorResponse);

    newError.message =
      (errorResponse.i18n && t(errorResponse.i18n.key, errorResponse.i18n.parameters)) ||
      errorResponse.message ||
      t('Error.Category.BadRequest.message');

    return newError;
  }
}
